module.exports = __webpack_public_path__ + "img/ad-spgg.bf4ed5ab.png";